
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 22h-1.67a2 2 0 01-2-2v-5.37a.92.92 0 00-.69-.93.84.84 0 00-.892.482.85.85 0 00-.078.358V20a2 2 0 01-2 2H11a2 2 0 01-2-2v-5.46a6.5 6.5 0 0113 0V20a2 2 0 01-2 2zm-4.5-10.31c.156-.01.313-.01.47 0a2.91 2.91 0 012.36 2.9V20H20v-5.46a4.5 4.5 0 10-9 0V20h1.67v-5.46a2.85 2.85 0 012.83-2.85zM6 22H4a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2zM4 10v10h2V10H4zM5 7a3 3 0 110-6 3 3 0 010 6zm0-4a1 1 0 100 2 1 1 0 000-2z"}})])
          )
        }
      }
    